export const imgMap = require("./05_Map.jpg");
export const imgIG = require("./06_Instagram_Logo.png");
